import { useMutation } from '@tanstack/react-query';
import { AuthService } from '@/infra/services/auth';
import Api from '@/services/api';

interface SignInParams {
	email: string;
	password: string;
	remember?: boolean;
}

const Service = AuthService.getInstance();

export function useSignIn() {
	return useMutation({
		mutationFn: (params: SignInParams) => Service.signIn(params),
		onSuccess: ({ token }) => {
			Api.defaults.headers.Authorization = `Bearer ${token}`;
		}
	});
}
